import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { gtWalsheim } from "@/fonts/gtWalsheim";

export interface ChipProps {
  variant:
    | "primary"
    | "secondary"
    | "disabled"
    | "danger"
    | "success"
    | "yellow"
    | "purple";
  size?: "sm" | "md";
  startAdornment?: ReactNode;
  children: ReactNode;
  className?: string;
}

const chipVariants: Record<ChipProps["variant"], string> = {
  primary: "bg-action-subtle text-brand-blue",
  secondary: "bg-action-disabled text-content-secondary",
  disabled: "bg-brand-gray text-action-disabled-content",
  success: "bg-[#D3F5DF] text-[#067647]",
  yellow: "bg-[#FCEFA0] text-[#8A6A00]",
  purple: "bg-[#EFE9FC] text-[#5B3BB0]",
  danger: "bg-[#FFEEEE] text-[#CE2C31]",
};

const chipSizes: Record<NonNullable<ChipProps["size"]>, string> = {
  sm: "px-[7px] py-[2px] text-[11px] font-bold",
  md: "px-3 py-1 text-[13px] font-medium",
};

export function Chip({
  variant,
  size = "md",
  startAdornment,
  children,
  className,
}: ChipProps) {
  return (
    <span
      className={twMerge(
        "inline-flex shrink-0 items-center gap-[5px] rounded-xl whitespace-nowrap",
        gtWalsheim.className,
        chipVariants[variant],
        chipSizes[size],
        className,
      )}
    >
      {startAdornment && (
        <div className="[&_svg]:size-[11px]">{startAdornment}</div>
      )}
      {children}
    </span>
  );
}
